import { DefaultService } from '@/services/DefaultService';

export default class AssProdutoLicencaService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

  findByIdProduto(column, order, page = 0, limit = 50, idproduto, situacao, ...params) {
    return this._http.get(encodeURI(`${this._env}/ven/produto/assprodutolicenca/getByProdutos.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idproduto}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
      return res.body;
    }, err => {
      this.verifyError(err);
      throw new Error('Problems while jobs are loading');
    });
	}

  findLicencasNaoAssociadosProduto(column, order, page = 0, limit = 50, idproduto, ...params) {
    return this._http.get( encodeURI(`${this._env}/ven/produto/assprodutolicenca/getnaoassociados.json?page=${page}&limit=${limit}&order=${order}&column=${column}&idproduto=${idproduto}&param=${params}`), this._headers ).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
    }

    save(form) {
    return this._http.post(`${this._env}/ven/produto/assprodutolicenca`, form, this._headers).then(res => {
        return res.body;
    }, err => {
        this.verifyError(err);
        throw err;
    });
    }

    updateSituacao(produtolicenca) {
        return this._http.post(`${this._env}/ven/produto/assprodutolicenca/updatesituacao`, produtolicenca, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
      }
}